import { render, staticRenderFns } from "./policy-sub-form.vue?vue&type=template&id=65d15960&scoped=true&"
import script from "./policy-sub-form.vue?vue&type=script&lang=js&"
export * from "./policy-sub-form.vue?vue&type=script&lang=js&"
import style0 from "./policy-sub-form.vue?vue&type=style&index=0&id=65d15960&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d15960",
  null
  
)

export default component.exports